<via-loading-spinner *ngIf="loading"></via-loading-spinner>
<via-keyword-filter-bar
    (searchFilters)="searchFiltersByText($event)"
    (clearSearch)="resetSearch()"
    [isDisabled]="selectedPromotions.length > 0"></via-keyword-filter-bar>
<div class="e-scrollable-area">
    <h3 class="e-filter-options-heading">All Promotions</h3>
    <via-checkbox-tree
        *ngIf="promotionsTree.length > 0"
        [tree]="promotionsTree"
        (onChange)="selectionChanged()"
        [branchCount]="3"
        (selectedSingularNodeChange)="onCheckboxStateChange($event)"
        [events]="eventsSubject.asObservable()">
    </via-checkbox-tree>
    <ng-container *ngIf="noResultsMessage !== ''">
        <div class="e-no-results-found-text">{{noResultsMessage}}</div>
    </ng-container>
    <p *ngIf="showError">{{ errorMessage }}</p>
</div>
